import * as React from "react";
import { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputBase,
  Radio,
  RadioGroup,
  Snackbar,
  Tooltip,
  Typography,
  DialogContent,
  DialogActions,
  TextField,
  NativeSelect,
  Select,
  Chip,
  ListItemText,
  Dialog,
  DialogTitle,
  InputAdornment,
  MenuItem
} from "@material-ui/core";
import { TextBar } from "src/components/sub-components/TextBar";
import { alpha, createTheme, makeStyles, Theme, ThemeProvider } from "@material-ui/core/styles";
import { primaryBlue, primaryGray, white } from "src/components/colors";
import { environment } from "src/environments/environment";
import { AddIconLarge, CloseIcon, DownArrow, QuestionIcon, UpArrow , UploadFile,Pointer} from "src/components/Icons";
import AddNewDecoder from "./CreateCodec";
import ReactSwitch from "react-switch";
import { AlertBar } from "src/components/sub-components/AlertBar";
import { useHistory } from 'react-router-dom';
import { Alert } from "@material-ui/lab";
import axios from "axios";
import { AddDeviceParameterConfiguration } from "./AddDeviceParameterConfiguration";
import { BootstrapInput } from "../../product-types/add-new-firmware/steps/Step1";
import { CloseIconColor } from "src/components/Icons";
import { blue } from "@material-ui/core/colors";
import useStyles from "src/app/maintenance/assets/styles";
import { AddSensors } from "./AddSensorComponent";
import { addSensor, getAllSensors } from "src/app/maintenance/test-automation/components/apiHelper";
import { capitalizeWords } from "src/app/utils";
import Cookies from "js-cookie";
import Dragger from "antd/lib/upload/Dragger";
import { DragDrop } from "src/components/sub-components/DragAndDrop";
import AddBaseVersion from "./AddBaseVersion";
import { DialogPopup } from "src/app/maintenance/test-automation/components/DialogPopup";
import{uploadFlowChart,flowChartConfig} from 'src/app/product-types/api-helper/apiHelper'
import { Close } from '@material-ui/icons';
import { hasPackagePermission } from "../../authentication/package.permission";
export function DefineProductTypeComponent(props) {
  const classes = local();
  const style = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showSensorPopup, setShowSensorPopup] = useState(false);
  const [showActuatorPopup, setShowActuatorPopup] = useState(false);
  const [showSensorOptions, setShowSensorOptions] = useState(false);
  const [showActuatorOptions, setShowActuatorOptions] = useState(false);
  const [isConnectionDropDown, setIsConnectionDropDown] = useState(false);
  const [isProtocolDropDown, setIsProtocolDropDown] = useState(false);
  const [isDataFormatDropDown, setIsDataFormatDropDown] = useState(false);
  const [isInputTypeDropDown, setIsInputTypeDropDown] = useState(false);
  const [isFormatDropDown, setIsFormatDropDown] = useState(false);
  const [isCodecDropDown, setIsCodecDropDown] = useState(false);
  const [addAnotherProduct, setAddAnotherProduct] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isToggled, setIsToggled] = useState(true);
  const [otaUpgradable, setOtaUpgradable] = useState(true);
  const [isTranscoding, setIsTranscoding] = useState(false);
  const [showCreateCodecDialog, setShowCreateCodecDialog] = useState(false);
  const [toaster, setToaster] = useState(false);
  const [reqSuccess, setReqSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredSensors, setFilteredSensors] = useState([]);
  const [isAddSensorPopup,setIsAddSensorPopup] = useState(false)

  const [sensors, setSensors] = useState([]);
  const [actuators, setActuators] = useState([]);
  const [sensorsOfDevice, setSensorsOfDevice] = useState([]);
  const [actuatorsOfDevice, setActuatorsOfDevice] = useState([]);
  const [step, setStep] = useState("select");
  const [codecs, setCodecs] = useState([]);
  const [selectedCodec, setSelectedCodec] = useState('');
  const [productName, setProductName] = useState("");
  const [protocol, setProtocol] = useState("");
  const [dataFormat, setDataFormat] = useState("");
  const [connectivity, setConnectivity] = useState("");
  const [persistenceValue, setSelectedPersistence] = useState('');
  const [codecToSend, setCodecToSend] = useState("");
  const [remotelyConfigurable, setRemotelyConfigurable] = useState(true);
  const [newSensorName,setNewSensorName] = useState("")
  const [newSensorCode,setNewSensorCode] = useState("")
  const [sensorErrors,setSensorErrors] = useState({
    sensorNameError:null,
    sensorCodeError:null
  })

  //Error Messages
  const [errors, setErrors] = useState({
    productNameError: null,
    sensorsError: null,
    actuatorsError: null,
    protocolError: null,
    dataFormatError: null,
    connectivityError: null,
    persistenceError: null,
    parametersError:null,
    codecError:null
  })
  const theme = createTheme({
    typography: {
      body1: {
        fontSize: '14px', 
        fontFamily:'poppins'
      },
    },
  });

  const connectivityOptions = ["WIFI", "GSM"];
  const protocolOptions = hasPackagePermission('Protocol') ? ["MQTT", "HTTP"] : ["MQTT"];
  const dataFormatOptions = ["String", "Json"];
  const inputTypeOptions = ["Text", "JSON", "HTML"]
  const formatOptions = ["String", "Integer", "Double", "Float", "Char"];

  //add version states
  const [productVersion, setProductVersion] = useState("");
  const [binFile, setBinFile] = useState<File | null>(null);

  const [flowchartFileList, setFlowchartFileList] = useState([]);
  const [flowChart, setFlowChart] = useState<File | null>(null);
  const [flowChartName, setFlowChartName] = useState("");

  const [versionError, setVersionError] = useState({
    isError: false,
    message: "",
    });
  const [binError, setBinError] = useState({ error: false, errorMsg: "" });
  const [availableBinfiles, setAvailableBinFiles] = useState([]);

  const [addParameter, setAddParameter] = useState(false);

  const [mainType, setMainType] = useState(""); // network , topic or message
  const [type, setType] = useState("");
  const [index, setIndex] = useState(-1);

  //parameter inputs
  const [parameter, setParameter] = useState("");
  const [id, setId] = useState("");
  const [inputType, setInputType] = useState("");
  const [defaultVal, setDefaultVal] = useState("");
  const [format, setFormat] = useState("");
  const [join, setJoin] = useState([]);

  //final states that should send to BE ***************
  const [parameters, setParameters] = useState([]);
  const [parametersAddedError, setParametersAddedError] = useState(false);
  const [parameterError, setParameterError] = useState({
    error: false,
    errorMsg: "",
  });
  const [idError, setIdError] = useState({ error: false, errorMsg: "" });
  const [formatError,setFormatError]=useState({error:false,errorMsg:""})
  const [inputTypeError,setInputTypeError]=useState({error:false,errorMsg:""});
  const [defaultValueError,setDefaultValueError]=useState({error:false,errorMsg:""})

  const [networkVisibility, setNetworkVisibility] = useState(false);
  const [topicVisibility, setTopicVisibility] = useState(false);
  const [messageVisibility, setMessageVisibility] = useState(false);

  const [open, setOpen] = useState(true);
  const [openOTA, setOpenOTA] = useState(false);

  const [showNotAvailablePopup, setShowNotAvailablePopup] = useState({
    open: false,
    featureName: '',
  });

    useEffect(() => {
      axios.get(`${environment.host}/core/product/configDetails`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      })
        .then((response) => {
          if (response.data.content !== undefined) {
            setAvailableBinFiles(response.data.content.availableBinFiles[0]); 
          }
        })
        .catch((err) => {
          console.error("Failed to fetch available bin files:", err);
        });
    }, []);

  const openNetworkVisibility = () => {
    setNetworkVisibility(!networkVisibility);
  };
  const openTopicVisibility = () => {
    setTopicVisibility(!topicVisibility);
  };
  const openMessageVisibility = () => {
    setMessageVisibility(!messageVisibility);
  };
  function isCharValid(value) {
    return /^.$/.test(value); // any single character
   // return /^[a-zA-Z]$/.test(value);  //any single alphabet
}
function isNumeric(value) {
  return !isNaN(value) && !isNaN(parseFloat(value));
}
function isStrictInteger(value) {
  if(isNaN(value)){
    return false; // Return false for invalid numbers
  }
  const num = parseFloat(value);
  return Number.isInteger(num) && value.indexOf('.') === -1;
}

  const  validateDefaultValueFormat=(format,defaultValue)=>{
    let valid = true;
    format = format.toLowerCase();
    switch (format) {
        case "string":
          if (isNumeric(defaultValue)) {
            valid = false; 
            setDefaultValueError({error:true,errorMsg:"The input cannot be 'integer' only."})
           }
           break
        case "char":
           if (!isCharValid(defaultValue)){
           valid= false;
           setDefaultValueError({error:true,errorMsg:"Cannot add more than 1 character"})
           }
            break;
        case "double":
        case "float":
            if (!isNumeric(defaultValue)) {
                valid = false; // Must be numeric
                setDefaultValueError({error:true,errorMsg:"The input must be a numeric value"}) 
            }
            break;
        case "integer":
            if (!isStrictInteger(defaultValue)) {
                valid = false; // Must be a valid integer
                setDefaultValueError({error:true,errorMsg:"The input must be an integer"})
            }
            break;
        default:
            break;
    }

    return valid;
}
  
  const readParameters = (values) => {
    if (type === "add-new") {
      let error;
      if (values.parameter === "" || values.parameterId === ""||values.inputType === "" || values.defaultValue === ""||values.format==="") {
        error = true;
        if (values.parameter === "") {
          setParameterError({
            error: true,
            errorMsg: "Parameter Name is required",
          });
        }
        if (values.parameterId === "") {
          setIdError({ error: true, errorMsg: "Id is required" });
        }
        if (values.defaultValue === "") {
          setDefaultValueError({error: true, errorMsg: "Default value is required"});
        }
        if (values.inputType === "") {
          setInputTypeError({error: true, errorMsg: "Input type is required"});
        }
        if (values.format === "") {
          setFormatError({error: true, errorMsg: "Format is required"});
        }
        if (error === true) {
          return;
        }
      }
      let formatMatchErrorCheck= validateDefaultValueFormat(values.format,values.defaultValue);
      if (!formatMatchErrorCheck){
        return;
      };
    
      if (parameters.filter((obj) => obj.parameterId === values.parameterId).length > 0) {
        setIdError({ error: true, errorMsg: "parameter Id Already exist" });
        return;
      }
      //save as decimal if it is entered as integer.
      if ((values.format.toLowerCase() === "float" || values.format.toLowerCase() === "double") && isStrictInteger(values.defaultValue)) {
        const floatValue = parseFloat(values.defaultValue);
        const formatedFloatValue = floatValue.toFixed(1); // Ensure one decimal place 
        values.defaultValue=formatedFloatValue;
      }
  
      setDefaultValueError({error:false,errorMsg:""});
      setParameters((current) => [...current, values]);
    }
    if (type === "edit" && index !== -1) {
      const keys = Object.keys(values);
      let error;
      if (values.parameter === "" || values.parameterId === ""||values.inputType === "" || values.defaultValue === ""||values.format==="") {
         error=true;
        if (values.parameter === "") {
          setParameterError({
            error: true,
            errorMsg: "Parameter Name is required",
          });
        }
        if (values.defaultValue === "") {
          setDefaultValueError({error: true, errorMsg: "Default value is required"});
        }
        if (values.inputType === "") {
          setInputTypeError({error: true, errorMsg: "Input type is required"});
        }
        if (values.format === "") {
          setFormatError({error: true, errorMsg: "Format is required"});
        }
        if (values.parameterId === "") {
          setIdError({error: true, errorMsg: "Parameter Id is required"});}
        if (error==true){
          return;}
        
      }
      let formatMatchErrorCheck= validateDefaultValueFormat(values["format"],values["defaultValue"]);
      if (!formatMatchErrorCheck){return;}
      if ((values.format.toLowerCase() === "float" || values.format.toLowerCase() === "double") && isStrictInteger(values.defaultValue)) {
        const floatValue = parseFloat(values.defaultValue);
        const formatedFloatValue = floatValue.toFixed(1); // Ensure one decimal place 
        values.defaultValue=formatedFloatValue;
      }
      keys.map((k) => {
        if (values[k] !== "") {
          parameters[index][k] = values[k];
        }
      });
      setDefaultValueError({error:false,errorMsg:""});

      setParameters(parameters);
      setType("");
    }
    setParameter("");
    setId("");
    setInputType("");
    setDefaultVal("");
    setFormat("");
    setJoin([]);
    setAddParameter(false);
  };

  const deleteParameter = (index) => {
    let parameterIdToDelete=parameters[index].parameterId;
      let updatedParams=parameters;
      parameters.forEach(parameter=>
        {if (parameter.parameterId!==parameterIdToDelete && parameter.joinParameter.includes(parameterIdToDelete)){
          const updatedJoinParameter=parameter.joinParameter.filter(i=>i!=parameterIdToDelete)
          updatedParams=updatedParams.map(p=>p.parameterId==parameter.parameterId?{...p,joinParameter:updatedJoinParameter}:p);
        }})
     const updatedParamList=updatedParams.filter(p=>p.parameterId!==parameters[index].parameterId);
     setParameters(updatedParamList);
     if (!parameters || updatedParamList.length === 0) {
      setParametersAddedError(true);
    } 
  };

  const openAddParameter = (mainType, type, i) => {
    setAddParameter(true);
    setMainType(mainType);
    setType(type);
    setIndex(i);
    if (type === "edit") {
      setInputType(parameters[i].inputType);
      setFormat(parameters[i].format);
      setJoin(parameters[i].joinParameter);
      setDefaultVal(parameters[i].defaultValue);
      setId(parameters[i].parameterId);
      setParameter(parameters[i].parameter);
    }
  };

  const closeAddParameter = () => {
    setType("");
    setAddParameter(false);
    setParameter("");
    setId("");
    setInputType("");
    setDefaultVal("");
    setFormat("");
    setJoin([]);
    setParameterError({ error: false, errorMsg: "" });
    setIdError({ error: false, errorMsg: "" });
    setDefaultValueError({error:false,errorMsg:""});
    setInputTypeError({error:false,errorMsg:""});
    setFormatError({error:false,errorMsg:""});
  };

  const selectJoin = (e) => {
    setJoin(e.target.value);
  };
  
  const removeJoin = (value) => {
    setJoin(join.filter((d) => d !== value));
  };


  // Event listener to handle clicks outside dropdowns
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        showSensorOptions ||
        showActuatorOptions ||
        isConnectionDropDown ||
        isProtocolDropDown ||
        isDataFormatDropDown ||
        isCodecDropDown
      ) {
        if (
          !event.target.closest('.sensor-dropdown') &&
          !event.target.closest('.actuator-dropdown') &&
          !event.target.closest('.connection-dropdown') &&
          !event.target.closest('.protocol-dropdown') &&
          !event.target.closest('.dataformat-dropdown') &&
          !event.target.closest('.codec-dropdown')
        ) {
          setShowSensorOptions(false);
          setShowActuatorOptions(false);
          setIsConnectionDropDown(false);
          setIsProtocolDropDown(false);
          setIsDataFormatDropDown(false);
          setIsCodecDropDown(false);
        }
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [
    showSensorOptions,
    showActuatorOptions,
    isConnectionDropDown,
    isProtocolDropDown,
    isDataFormatDropDown,
    isCodecDropDown,
  ]);

  useEffect(() => {
    fetchCodecs();
    fetchMetaData();
    getAllSensores()
  }, []);

  // Fetch MetaData from the API endpoint
  const fetchMetaData = () => {
    setLoading(true);
    const accessToken = Cookies.get("ACCESS_TOKEN");
    axios.get(`${environment.host}/core/meta-data`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setActuators(response.data.content.actuators.sort((a, b) => (a.name < b.name ? -1 : 1)));
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching metadata:', error);
        setLoading(false);
      });
  };

  const getAllSensores =async () =>{
    try{
      const response =await getAllSensors()
      if(response){
        const sortedSensors = response.sort((a, b) => (a.codeValue < b.codeValue ? -1 : 1));
        setSensors(sortedSensors);
        setFilteredSensors(sortedSensors);
      }
    }catch(error){
      setToaster(true)
      setReqSuccess(false)
      setErrorMessage(error.message)
    }
  }

  // Fetch product types from the API endpoint
  const fetchCodecs = async () => {
    const accessToken = Cookies.get("ACCESS_TOKEN");
    await axios.get(`${environment.host}/core/codec`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setCodecs(response.data.content);
      })
      .catch((error) => {
        console.error('Error fetching codecs:', error.response.statusText);
      });
  };

  const addParameterCancel = () => {
    setOpen(false);
    setParameters([]);
    setRemotelyConfigurable(true);
    setParameterError({ error: false, errorMsg: "" });
    setIdError({ error: false, errorMsg: "" });
  }

  const addParameterDone = () => {
    setType("");
    setOpen(false);
    setParameterError({ error: false, errorMsg: "" });
    setIdError({ error: false, errorMsg: "" });
  };

  //API endpoint for the save product type
  const saveProductType = async (binFile?: File) => {
    checkTranscoding();
  
    const dependencyMap = new Map();
    const deviceParameterConfiguration = {};
    const versions = [];
  
    parameters.forEach(param => {
      const paramId = param.parameterId;
      const joinParameters = param.joinParameter;
      if(joinParameters){
      joinParameters.forEach(joinParamId => {
        if (!dependencyMap.has(joinParamId)) {
          dependencyMap.set(joinParamId, []);
        }
        const joinList = dependencyMap.get(joinParamId);
        if (joinList && !joinList.includes(paramId)) {
          joinList.push(paramId);
        }
  
        if (!dependencyMap.has(paramId)) {
          dependencyMap.set(paramId, []);
        }
        const paramList = dependencyMap.get(paramId);
        if (paramList && !paramList.includes(joinParamId)) {
          paramList.push(joinParamId);
        }
      });
     }
    });
  
    const joinParametersObj = {};
    Array.from(dependencyMap).forEach(([key, value]) => {
      joinParametersObj[key] = value;
    });
  
    const version = {};
    version["versionNum"] = (productVersion.length>0&&binFile)?productVersion:"0.0.0"; //allow base version only when version is valid and binfile added
    version["status"] = "APPROVED";  //remove 
    version["remoteConfigurations"] = parameters.map(({ joinParameter, ...rest }) => rest);
    version["joinParameters"] = joinParametersObj;
    version['majorVersionUpgrade']=false;
    if(binFile&&productVersion.length>0&&flowChart &&flowChartName.length>0){
    let flowChartUpload=await uploadFlowChart(flowChart,flowChartConfig);
    console.log('url,',flowChartUpload);
    if(flowChartUpload.ok){
    version['flowChartURL']== flowChartUpload.url
    version['flowChartFileName']=flowChartName;
    }
    }
    versions.push(version);
  
    const productTypeDTO = {
      productName: productName,
      sensorCodes: sensorsOfDevice.map(sensor => sensor.code),
      actuatorCodes: actuatorsOfDevice.map(actuator => actuator.code),
      persistence: false,
      protocol: protocol,
      connectivity: connectivity,
      codecName: codecToSend,
      transcoder: true,
      otaUpgradable: true,
      remotelyConfigurable: true,
      dataFormat: dataFormat,
      versions: versions
    };
  
    if (persistenceValue === 'true') {
      productTypeDTO.persistence = true;
    }
  
    if (isToggled === true) {
      productTypeDTO.transcoder = false;
    }
  
    if (otaUpgradable === true) {
      productTypeDTO.otaUpgradable = false;
    }
  
    if (remotelyConfigurable === true) {
      productTypeDTO.remotelyConfigurable = false;
    }
  
    const formData = new FormData();
    const jsonBlob = new Blob([JSON.stringify(productTypeDTO)], { type: "application/json" });
    formData.append("productTypeDTO", jsonBlob);
  
    if (binFile && productVersion.length>0) {
      formData.append("binFile", binFile);
    }
  
    try {
      const response = await axios.post(`${environment.host}/core/product/productType`, formData, {
        headers: {
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`
        }
      });
  
      if (response.data.message === 'Success') {
        setReqSuccess(true);
        setErrorMessage('Product Type Added Successfully');
        setToaster(true);
        resetFormFields();
      }
  
      return response.data;
  
    } catch (error) {
      setLoading(false);
      setToaster(true);
      setReqSuccess(false);
      setTimeout(() => {
        setToaster(false);
      }, 4000);
  
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
        throw new Error(error.response.data.message);
      } else {
        setErrorMessage("Something went wrong");
        throw new Error("Something went wrong");
      }
    }
  };   

  const resetFormFields = () => {
    setProductName('');
    setSensorsOfDevice([]);
    setShowSensorPopup(false)
    setActuatorsOfDevice([]);
    setShowActuatorPopup(false)
    setConnectivity('');
    setProtocol('');
    setDataFormat('');
    setOtaUpgradable(true);
    setRemotelyConfigurable(true);
    setSelectedPersistence('');
    setCodecToSend('');
    setAddAnotherProduct(false);
    setIsSubmitted(false);
    setIsToggled(true);
    setIsTranscoding(false);
    setParameters([]);
  };

  const handleCloseToaster = () => {
    setToaster(false);
  };

  const redirectToHome = () => {
    resetFormFields();
    setTimeout(() => {
      history.push(addAnotherProduct ? `/DefineProductType` : ``)
    }, 2000);
  };
  const handleBack = () => {
    resetFormFields();
    history.push(``);
  }

  const handleSave = async () => {
    console.log('Save')
    let isError = false;
    setIsSubmitted(true);

    const validationError = validationForm()
    setErrors(validationError)
    if (Object.keys(validationError).length > 0) {
      return;
    }
    setLoading(true);
    try {
      const response = await saveProductType(binFile);
      if (response.message === 'Success') {
        if (addAnotherProduct) {
          setLoading(false);
        } else {
          redirectToHome();
        }
      }
    } catch (error) {
      console.error('Error saving product type:', error);
      setLoading(false);
    }
  };

  const handleSensorPopup = () => {
    setIsAddSensorPopup(!isAddSensorPopup);
    setSensorErrors((prev)=>({
      ...prev,
      sensorCodeError:null,
      sensorNameError:null
    }))
  };
  const handleActuatorPopup = () => {
    setShowActuatorPopup(!showActuatorPopup);
  };
  const handleProtocolChange = (option) => {
    setProtocol(option);
    setErrors(prevErrors => ({
      ...prevErrors,
      protocolError: null
    }));
  };
  const handleConnectivityChange = (option) => {
    setConnectivity(option);
    setErrors(prevErrors => ({
      ...prevErrors,
      connectivityError: null
    }));
  };
  const handleInputTypeChange = (option) => {
    setInputType(option);
    setInputTypeError({error:false,errorMsg:""})
  }

  const handleFormatChange = (option) => {
    setFormat(option);
    setFormatError({error:false,errorMsg:""})
  };
  const handleCodecChange = (option) => {
    setCodecToSend(option);
  };
  const handleCodecCreation = (name) => {
    setCodecToSend(name);
  };
  const handleCheckboxChange = (event) => {
    setAddAnotherProduct(event.target.checked);
  };

  const handleDataFormatChange = (option) => {
    setDataFormat(option);
    setErrors(prevErrors => ({
      ...prevErrors,
      dataFormatError: null
    }));
  };
    function isValidProductName(input) {
      const regex = /^[A-Za-z0-9_-]+$/;
      return regex.test(input);
  }
  const validationForm = () => {
    let error: any = {}
    if (productName.trim() === "") {
      error.productNameError = "Product Type is Required"
    }
    else if (!isValidProductName(productName)) {
      error.productNameError = "Only letters, numbers, hyphens, and underscores allowed";
    }
    if (sensorsOfDevice.length == 0 && actuatorsOfDevice.length == 0) {
      if (sensorsOfDevice.length == 0) {
        error.sensorsError = "Sensors are Required"
      }
      if (actuatorsOfDevice.length == 0) {
        error.actuatorsError = "Actuators are Required"
      }
    }

    if (protocol.trim() === "") {
      error.protocolError = "Protocol is Required"
    }

    if ((!otaUpgradable || !remotelyConfigurable) && dataFormat.trim() === "") {
      error.dataFormatError = "Data Format is Required"
    }

    if (!remotelyConfigurable && (!parameters || parameters.length === 0)) {
      error.parametersError = "Remote Config Parameters are Required";
    }
    
   if (connectivity.trim() === "") {
      error.connectivityError = "Connection is Required"
    }

    if (persistenceValue === '') {
      error.persistenceError = "Persistence is Required"
    }
    if(isTranscoding && codecToSend===""){
      error.codecError = "Codec is Required"
  }
    return error

  }

  const handleSensorSelection = (sensorName) => {
    if (sensorName === 'AddSensor') {
      setShowSensorPopup(true);
    } else if(sensorName !== "") {
      const selectedSensor = sensors.find(sensor => sensor.codeValue === sensorName);
      if (selectedSensor && !sensorsOfDevice.some(sensor => sensor.codeValue === selectedSensor.codeValue)) {
        setSensorsOfDevice(prevSensors => [
          ...prevSensors,
          { name: selectedSensor.codeValue, code: selectedSensor.code }
        ]);
      }
      setErrors(prevErrors => ({
        ...prevErrors,
        sensorsError: null,
        actuatorsError: null
      }));
    }
    setSearchQuery('');
    setFilteredSensors(sensors);
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    if (query === '') {
      setFilteredSensors(sensors);
    } else {
      const filtered = sensors.filter(sensor => sensor.codeValue.toLowerCase().includes(query.toLowerCase()));
      setFilteredSensors(filtered);
    }
  };

  const removeSensorFromDevice = (indexToRemove) => {
    setSensorsOfDevice(prevSensors =>
      prevSensors.filter((sensor, index) => index !== indexToRemove)
    );
  };

  const handleActuatorSelection = (actuatorName) => {
    if (actuatorName === 'AddSensor') {
      setShowActuatorPopup(true);
    } else {
      const selectedActuator = actuators.find(actuator => actuator.name === actuatorName);
      if (selectedActuator && !actuatorsOfDevice.some(actuator => actuator.name === selectedActuator.name)) {
        setActuatorsOfDevice(prevActuators => [
          ...prevActuators,
          { name: selectedActuator.name, code: selectedActuator.code }
        ]);
      }
    }
    setErrors(prevErrors => ({
      ...prevErrors,
      actuatorsError: null,
      sensorsError: null
    }));
  };
  const removeActuatorFromDevice = (indexToRemove) => {
    setActuatorsOfDevice(prevActuators =>
      prevActuators.filter((actuator, index) => index !== indexToRemove)
    );
  };

  const SensorPopup = () => {
    return (
      <Popup
        type="sensor"
        onClose={() =>
          setShowSensorPopup(false)
        } />
    );
  };
  const ActuatorPopup = () => {
    return (
      <Popup
        type="actuator"
        onClose={() =>
          setShowActuatorPopup(false)
        } />
    );
  };
  const Popup = ({ type, onClose }) => {
    return (
      <div style={{ color: 'black' }}>
        <div>
          <b>Need to add a {type === 'sensor' ? 'sensor' : 'actuator'}?</b> <br />
          Contact the admin for assistance!
        </div>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '0px',
            right: '5px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <CloseIcon color='#2A7BEC'/>
        </button>
      </div>
    );
  };

  const NotAvailablePopup = ({ open, onClose, onCloseWithFeature, featureName, onUpgrade }) => {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '512px',
            maxWidth: '512px',
          },
        }}
      >
        <DialogTitle>
          <Grid container justifyContent="flex-end" alignItems="center">
            <IconButton onClick={onClose} size="small">
              <Close />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ marginBottom: '15px' }}>
            You've just configured a feature available only in the Basic package. To perform {featureName} operations, please upgrade your plan.
          </Typography>
          <Grid container justifyContent="flex-end" spacing={1}>
            <Grid item>
              <Button
                variant="contained"
                onClick={onUpgrade}
                className={style.buttonContained}
                style={{ backgroundColor: '#2A7CED', color: '#FFFFFF' }}
              >
                Upgrade Now
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={onCloseWithFeature}
                className={style.buttonOutlined}                
              >
                OK
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  };


  const showFeatureUnavailablePopup = (featureName) => {
    setShowNotAvailablePopup({
      open: true,
      featureName
    });
  };

  const handleChangeToggle = () => {
    handleTranscoding();
    setIsToggled(!isToggled)
    setIsCodecDropDown(false);
    setSelectedCodec("");
    setCodecToSend("");
    setStep("select");
  }
  const handleChangeOTAToggle = () => {
    const newValue = !otaUpgradable;
    setOtaUpgradable(newValue)
    if (!newValue) {
      setOpenOTA(true);
    } else {
      setOpenOTA(false);
    }
  }
  const handleCloseAddVersion=()=>{
    setOpenOTA(false)
  }
  const handleAddVersion=()=>{
    if (productVersion === "") {
      setVersionError({ isError: true, message: `Version Required` });
      return;
    }
    else if(productVersion=="0.0.0"){
      setVersionError({
        isError: true,
        message: `Invalid Version Number`,
      });
      return;
    }
    if (binFile) {
      

      if (!binFile.name.endsWith(".bin")) {
        setBinError({ error: true, errorMsg: "Invalid file type" });
        return;
      } else {
        setBinError({ error: false, errorMsg: "" });
      }
      if (availableBinfiles.some(name => name === binFile.name)) {
        setBinError({ error: true, errorMsg: "Filename already exists" });
        return;
      }
    }
    else{
      setBinError({ error: true, errorMsg: "Bin file is required" });
      return;
    }
    if (!hasPackagePermission("OTAManger")) {
      showFeatureUnavailablePopup('OTA Manager')
    } else {
      setOpenOTA(false);
    }
  }

  const handleChangeRemoteToggle = () => {
    const newValue = !remotelyConfigurable;
  
    setRemotelyConfigurable(newValue);
  
    if (!newValue) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };
  
  
const handleTranscoding = () => {
    if (isToggled) {
      setIsTranscoding(true);
    }
  }

  const checkTranscoding = () => {
    if (isTranscoding) {
      if (codecToSend === "") {
        localStorage.setItem('transcodingIsPending', 'true');
      }
    }
  }
  const handleCreateCodecClick = () => {
    setStep("create");
    setShowCreateCodecDialog(!showCreateCodecDialog);
  };
  const handleSelectCodecClick = () => {
    setStep("select");
    setSelectedCodec("");
    fetchCodecs();
  };

  const successCallback = (message) => {
    if (message === "Success") {
      setLoading(false);
      setToaster(true);
      setErrorMessage('Codec Added Successfully');
      setReqSuccess(true);
    }
  }

  const isAddSensor = () =>{
    setShowSensorOptions(!showSensorOptions)
    setIsAddSensorPopup(false)
  }

  const sensorValidation = () =>{
    let errors :any = {}
    if(newSensorName == ""){
      errors.sensorNameError = 'Sensor name required'
    }else if(sensors.some(sensor => sensor.codeValue.toLowerCase() === newSensorName.toLowerCase())){
      errors.sensorNameError = 'Sensor name already exist'
    }
    if(newSensorCode == ""){
      errors.sensorCodeError = 'Sensor code required'
    }else if(sensors.some(sensor => sensor.code.toLowerCase() === newSensorName.toLowerCase())){
      errors.sensorCodeError = 'Sensor code already exist'
    }
    return errors
  }

  const handleSensorName = (event) =>{
    const value = event.target.value
    setNewSensorName(value)
    if(value != ""){
      setSensorErrors((prev) =>({
        ...prev,
        sensorNameError : null
      }))
    }
  }

  const handleSensorCode = (event) =>{
    const value = event.target.value
    setNewSensorCode(value)
    if(value != ""){
      setSensorErrors((prev) =>({
        ...prev,
        sensorCodeError : null
      }))
    }
  }

  const handleAddSensor = async() =>{
    const isValid = await sensorValidation();
    if(Object.values(isValid).length != 0){
      setSensorErrors(isValid)
      return;
    }
    setLoading(true)
    const data =[{
      code:newSensorCode.toUpperCase(),
      codeValue : capitalizeWords(newSensorName)
    }]
    console.log(data)
    try{
      const response = await addSensor(data)
      if(response){
        getAllSensores()
        setIsAddSensorPopup(false)
      }
    }catch(error){
      setToaster(true)
      setReqSuccess(false)
      setErrorMessage(error.message)
    }finally{
      setLoading(false)
    }
  }

  

  return (
    <ThemeProvider theme={theme}>
    <div className={`testing`}>
      <div className="page-heading" style={{ marginBottom: "50px" }}>
        Step 01
      </div>

        <Grid container alignItems="center">
          <Grid item xs={12} md={12}
            style={{
              textAlign: "center",
              paddingBottom: "40px"
            }}
          >
            <h4>Define Product Type</h4>
          </Grid>
        </Grid>
        <Grid container className={style.root} style={{width:"60%"}}>
        <Grid container className={style.formContent}>
        <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} md={12}> 
        <Grid container alignItems="center" spacing={1}>
            <Grid item xs={12} md={12}>
              <Typography className={style.typo}>
                Product Name
                <span className={style.required}>*</span> 
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl className={style.input}>
                <input
                  className={style.formInput}
                  type="text"
                  placeholder="Add Product Name"
                  value={productName}
                  onChange={(e) => {
                    setProductName(e.target.value);
                    setErrors(prevErrors => ({
                      ...prevErrors,
                      productNameError: null
                    }));
                  }}
                />
                {errors.productNameError && (
                  <span className="form-error">
                    {errors.productNameError}
                  </span>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1} md={3}></Grid>
      </Grid>

          <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} md={12}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={12} md={12}>
              <Typography className={style.typo}>
                Sensors
                <span className={style.required}>*</span> 
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <div className={`cloud-container ${showSensorPopup ? classes.popup : ''}`}>
                {showSensorPopup ? (
                  <label className="no-data-available" style={{ width: "100%" }}>
                    <SensorPopup />
                  </label>
                ) : (
                  <>
                    {sensorsOfDevice.length === 0 && (
                      <label className="no-data-available" style={{ width: "100%" }}>
                        No Sensor Added
                      </label>
                    )}
                    {sensorsOfDevice.map((sensor, index) => (
                      <Grid container key={index} className={style.cloudItem}>
                        <Grid item className={style.cloudItem_number}>{index + 1}</Grid>
                        <Grid item className={style.cloudItem_line}></Grid>
                        <Grid item className={style.cloudItem_text}>{sensor.name}</Grid>
                        <Grid item onClick={() => removeSensorFromDevice(index)} className={style.cloudItem_close}><CloseIcon color='#2A7BEC'/></Grid>
                      </Grid>
                    ))}
                  </>
                  )
                }
              </div>
                  <FormControl className={`${style.input} sensor-dropdown`}>
                    <div className={style.formInput} onClick={isAddSensor}>
                      <span style={{color: "grey"}}>
                        {showSensorOptions ? (
                          <InputBase
                            placeholder="Search Sensors"
                            style={{ fontFamily: "'Poppins',sans-serif", fontSize: '13px' }}
                            value={searchQuery}
                            onChange={handleSearchChange}
                            fullWidth
                            autoFocus
                          />
                        ) : (
                          <>Add Sensors</>
                        )}
                      </span>
                      {showSensorOptions ? <UpArrow /> : <DownArrow />}
                    </div>
                    {showSensorOptions && (
                      <Grid container className={classes.dropDownGrid}>
                        <Grid item xs={12} md={12}
                              className={style.option}
                              onClick={handleSensorPopup}
                        >
                          <div className={classes.addIcon}>
                            <AddIconLarge/>
                            <span style={{marginLeft: '5px'}}> Add Sensors </span>
                          </div>
                        </Grid>
                        {isAddSensorPopup && 
                          <AddSensors 
                            sensorNameChange={handleSensorName} 
                            sensorCodeChange={handleSensorCode} 
                            handleSave={handleAddSensor}
                            error = {sensorErrors}
                          />
                        }
                        {filteredSensors.map((sensor, index) => (
                          <Grid item xs={12} md={12}
                                className={style.option}
                                key={index}
                                onClick={() => handleSensorSelection(sensor.codeValue)}
                          >
                            <span style={{ marginLeft: '10px' }}> {sensor.codeValue} </span>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    {errors.sensorsError && (
                      <span className="form-error">
                        {errors.sensorsError}
                      </span>
                    )}
                  </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1} md={3}></Grid>
      </Grid>

      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} md={12}>
        <Grid container alignItems="center" spacing={1}>
            <Grid item xs={12} md={12}>
              <Typography className={style.typo}>
                Actuators
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <div className={`cloud-container ${showActuatorPopup ? classes.popup : ''}`}>
                {showActuatorPopup ? (
                  <label className="no-data-available" style={{ width: "100%" }}>
                    <ActuatorPopup />
                  </label>
                ) : (
                  <>
                    {actuatorsOfDevice.length === 0 && (
                      <label className="no-data-available" style={{ width: "100%" }}>
                        No Actuator Added
                      </label>
                    )}
                    {actuatorsOfDevice.map((actuator, index) => (
                      <Grid container key={index} className={style.cloudItem}>
                        <Grid item className={style.cloudItem_number}>{index + 1}</Grid>
                        <Grid item className={style.cloudItem_line}></Grid>
                        <Grid item className={style.cloudItem_text}>{actuator.name}</Grid>
                        <Grid item onClick={() => removeActuatorFromDevice(index)} className={style.cloudItem_close}><CloseIcon color='#2A7BEC'/></Grid>
                      </Grid>
                    ))}
                  </>
                )}
              </div>
              {!showActuatorPopup && (
                <>
                  <FormControl className={style.input} onClick={() => setShowActuatorOptions(true)}>
                    <Typography className={style.formInput}>
                      <span style={{ color: "grey" }}> Add Actuators </span>
                      {showActuatorOptions ? <UpArrow /> : <DownArrow />}
                    </Typography>
                    {showActuatorOptions && (
                      <Grid container className={classes.dropDownGrid}>
                        <Grid item xs={12} md={12}
                              className={style.option}
                              onClick={handleActuatorPopup}
                        >
                          <div style={{ margin: "0px", display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                            <AddIconLarge />
                            <span style={{ marginLeft: '5px' }}> Add Actuators </span>
                          </div>
                        </Grid>
                        {actuators.map((actuator, index) => (
                          <Grid item xs={12} md={12}
                                className={style.option}
                                key={index}
                                onClick={() => handleActuatorSelection(actuator.name)}
                          >
                            <span style={{ marginLeft: '10px' }}> {actuator.name} </span>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                    {errors.actuatorsError && (
                      <span className="form-error">
                        {errors.actuatorsError}
                      </span>
                    )}
                  </FormControl>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1} md={3}></Grid>
      </Grid>

      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} md={6}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={12} md={6}>
              <Typography className={style.typo}>
                Connectivity
                <span className={style.required}>*</span> 
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl className={style.input}>
                <Grid container style={{height: '40px'}}>
                  <Grid container className={style.formInput}
                    style={{ cursor: 'pointer' }}
                    alignContent='center'
                    onClick={() => setIsConnectionDropDown(true)}
                  >
                    <Grid item style={{ flex: 1 }}>
                      <input
                        placeholder="Select Connection"
                        className={classes.optionInput}
                        value={connectivity}
                        onChange={(e) => setConnectivity(e.target.value)}
                      />
                    </Grid>
                    <Grid item> {isConnectionDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                  </Grid>
                  {isConnectionDropDown && (
                    <div className={classes.dropdown}>
                      {connectivityOptions.map((option, index) => {
                        return (
                          <Grid item className={style.option} key={index}
                                onClick={() => {
                                  handleConnectivityChange(option)
                                }}
                          >
                            {option}
                          </Grid>
                        )
                      })
                      }
                    </div>
                  )}
                </Grid>
                {errors.connectivityError && (
                  <span className="form-error">
                    {errors.connectivityError}
                  </span>
                )}
              </FormControl>
            </Grid>
          </Grid>
      </Grid>

        <Grid item xs={12} md={6}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={12} md={6}>
              <Typography className={style.typo}>
                Protocol
                <span className={style.required}>*</span> 
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl className={style.input}>
                <Grid container style={{height: '40px'}}>
                  <Grid container className={style.formInput}
                    style={{ cursor: 'pointer' }}
                    alignContent='center'
                    onClick={() => setIsProtocolDropDown(true)}
                  >
                    <Grid item style={{ flex: 1 }}>
                      <input
                        placeholder="Select Protocol"
                        className={classes.optionInput}
                        value={protocol}
                        onChange={(e) => setProtocol(e.target.value)}
                      />
                    </Grid>
                    <Grid item> {isProtocolDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                  </Grid>
                  {isProtocolDropDown && (
                    <div className={classes.dropdown}>
                      {protocolOptions.map((option, index) => {
                        return (
                          <Grid item className={style.option} key={index}
                                onClick={() => {
                                  handleProtocolChange(option)
                                }}
                          >
                            {option}
                          </Grid>
                        )
                      })
                      }
                    </div>
                  )}
                </Grid>
                {errors.protocolError && (
                  <span className="form-error">
                    {errors.protocolError}
                  </span>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1} md={3}></Grid>
      </Grid>


      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} md={12}>
          <Grid container alignItems="center">
              <Typography className={style.typo}>
                Persistence
                <span className={style.required}>* </span>
                <Tooltip
                  title="Persistence in device end refers to the ability of a device to retain data or settings even after being powered off or restarted ensuring continuity and smooth operation"
                  classes={{ tooltip: classes.questionTooltip }}
                >
                  <IconButton style={{ padding: "0px" }}>
                    <QuestionIcon />
                  </IconButton>
                </Tooltip> 
              </Typography>
            <Grid item xs={12} md={12}
              style={{
                display: 'flex',
                justifyContent: 'flex-start'
              }}>
              <FormControl>
                <Grid container alignItems="center">
                  <RadioGroup row
                    value={persistenceValue}
                    onChange={(e) => {
                      setSelectedPersistence(e.target.value);
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        persistenceError: null
                      }));
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio className={style.radio} />}
                      label="True"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio className={style.radio}/>}
                      label="False"
                    />
                  </RadioGroup>
                  {isSubmitted && errors.persistenceError && (
                    <Grid item>
                      <span className="form-error">
                        {errors.persistenceError}
                      </span>
                    </Grid>
                  )}
                </Grid>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1} md={3}></Grid>
      </Grid>
      <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={12}> 
          <Grid container justifyContent="space-between">
            <Grid item xs={4}>
              <Typography className={style.typo}>
                OTA Upgradable
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography className={style.typo}>
                Remotely Configurable
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography className={style.typo}>
                Transcoding
              </Typography>
            </Grid>
          </Grid>

        <Grid container justifyContent="space-between" >
            <Grid item xs={4}>
              <FormControl>
                <ReactSwitch
                  checked={!otaUpgradable}
                  onChange={handleChangeOTAToggle}
                  offColor='#D9D9D9'
                  onColor='#2A7CED'
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={20}
                  width={40}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4} >
              <FormControl>
                <ReactSwitch
                  checked={!remotelyConfigurable}
                  onChange={handleChangeRemoteToggle}
                  offColor='#D9D9D9'
                  onColor='#2A7CED'
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={20}
                  width={40}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl>
                <ReactSwitch
                checked={!isToggled}
                onChange={handleChangeToggle}
                  offColor="#D9D9D9"
                  onColor="#2A7CED"
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={20}
                  width={40}
                />
              </FormControl>
          </Grid>
        </Grid>
        </Grid>
        <Grid item xs={1} md={3}></Grid>
      </Grid>

      {(!otaUpgradable || !remotelyConfigurable) && (
         <Grid item container xs={12} md={12} alignItems="center">
          <Grid item xs={12} md={12}>
            <Grid container alignItems="center">
                <Typography className={style.typo}>
                  Data Format
                  <span className={style.required}>*</span>
                </Typography>
              <Grid item xs={12} md={12}>
                <FormControl className={style.input}>
                  <Grid container style={{ height: '40px' }}>
                    <Grid container className={style.formInput}
                      style={{ cursor: 'pointer' }}
                      alignContent='center'
                      onClick={() => setIsDataFormatDropDown(true)}
                    >
                      <Grid item style={{ flex: 1 }}>
                        <input
                          placeholder="Select Data Format"
                          className={classes.optionInput}
                          value={dataFormat}
                          onChange={(e) => setDataFormat(e.target.value)}
                        />
                      </Grid>
                      <Grid item> {isDataFormatDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                    </Grid>
                    {isDataFormatDropDown && (
                      <div className={classes.dropdown}>
                        {dataFormatOptions.map((option, index) => {
                          return (
                            <Grid item className={style.option} key={index}
                              onClick={() => {
                                handleDataFormatChange(option)
                              }}
                            >
                              {option}
                            </Grid>
                          )
                        })
                        }
                      </div>
                    )}
                  </Grid>
                  {errors.dataFormatError && (
                    <span className="form-error">
                      {errors.dataFormatError}
                    </span>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      <DialogPopup
        open={openOTA}
        onClose={handleCloseAddVersion}
        title="Add New Version"
        dialogContent={<AddBaseVersion  
                        setBinFile={setBinFile} productVersion={productVersion} setProductVersion={setProductVersion}
                        setFlowChart={setFlowChart} flowChartName={flowChartName}  setFlowChartName={setFlowChartName} 
                        flowchartFileList={flowchartFileList} setFlowchartFileList={setFlowchartFileList}
                        binError={binError} setBinError={setBinError} versionError={versionError}/>}
        buttonRequired={true}
        dialogWidth="860px"
        cancel='Cancel'
        submit='Add'
        submitButtonColor="#2A7CED"
        onSubmit={handleAddVersion}
      />
      <>
        {(open && !remotelyConfigurable )&&  (
          <Dialog open={open} fullWidth maxWidth="md">
            <Grid container>
              <Grid item xs={10} md={10}>
                <DialogTitle>
                  {type === "view" ? "View" : type === "edit" ? "Edit" : "Add"}{" "}
                  Parameter
                </DialogTitle>
              </Grid>
              <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                <IconButton
                 onClick={() => {
                  if (addParameter) {
                    closeAddParameter();
                  } else {
                    if (!parameters || parameters.length === 0) {
                      setParametersAddedError(true);
                    } 
                    else{
                      setErrors(prevErrors => ({
                        ...prevErrors,
                        parametersError: null
                      }))
                    }

                      addParameterCancel();
                    
                  }
                }}
                
                >
                  <CloseIconColor />
                </IconButton>
              </Grid>
            </Grid>

            <DialogContent style={{ backgroundColor: '#F9F9F9', width: '100%' }}>
              {(!remotelyConfigurable && !addParameter) && (
                <Grid container>
                  <AddDeviceParameterConfiguration
                    openNetworkVisibility={openNetworkVisibility}
                    openTopicVisibility={openTopicVisibility}
                    openMessageVisibility={openMessageVisibility}
                    networkVisibility={networkVisibility}
                    topicVisibility={topicVisibility}
                    messageVisibility={messageVisibility}
                    open={(mainType, type, i) =>
                      openAddParameter(mainType, type, i)
                    }
                    parameters={parameters}
                    readParameters={(parameters) => readParameters(parameters)}
                    parametersAddedError={parametersAddedError}
                    deleteParameter={deleteParameter}
                  />
                </Grid>

              )}

              {addParameter && (
                <Grid container style={{ textAlign: "center", marginTop: "20px" }}>
                  <Grid item xs={6} style={{ textAlign: "left", paddingBottom: "20px" }}>
                    <Typography className={style.typo}>Parameter name<span className={style.required}>*</span> </Typography>
                    <FormControl className={style.input}>
                      <input
                      className={style.formInput}
                      disabled={type === "view" ? true : false}
                      onChange={(e) => {
                        setParameter(e.target.value);
                        setParameterError({ error: false, errorMsg: "" });
                      }}
                      value={
                        type === "view"
                          ? parameters[index].parameter
                          : parameter
                      }
                    />
                   
                    </FormControl>
                    {parameterError.error&&(                     
                      <Typography className={style.errorText}>{parameterError.errorMsg}</Typography>)}
                  </Grid>
                  <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}>
                    <Typography className={style.typo}>Parameter ID<span className={style.required}>*</span></Typography>
                    <FormControl className={style.input}>
                      {type === "edit" ? (
                        <Tooltip title="Parameter ID cannot be edited once saved" arrow>
                          <input
                            disabled
                            className={style.formInput}
                            type="number"
                            value={parameters[index].parameterId}
                          />
                        </Tooltip>
                      ) : (
                        <input
                          className={style.formInput}
                          disabled={type === "add-new" ? false : true}
                          type="number"
                          value={id}
                          onChange={(e) => {
                            setId(e.target.value);
                            setIdError({ error: false, errorMsg: "" });
                          }}
                        />
                      )}
                    </FormControl>
                    {idError.error&&(
                       <Typography className={style.errorText}>{idError.errorMsg}</Typography>)}
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={6}
                    style={{ textAlign: "left", paddingBottom: "20px" }}
                  >
                    <Typography className={style.label}>Input Type<span className={style.required}>*</span></Typography>
                    <FormControl className={style.input}>
                      <Grid container style={{height: '40px'}}>
                        <Grid container className={style.formInput}
                          style={{ cursor: 'pointer' }}
                          alignContent='center'
                          onClick={() => setIsInputTypeDropDown(!isInputTypeDropDown)}
                          >
                          <Grid item style={{ flex: 1 }}>
                            <input
                              disabled={type === "view"}
                              placeholder="Select Input Type"
                              className={classes.optionInput}
                              value={type === "view" ? parameters[index].inputType : inputType}
                              onChange={(e) => {setInputType(e.target.value);setInputTypeError({error:false,errorMsg:""})}}
                            />
                            </Grid>
                            <Grid item> {isInputTypeDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                          </Grid>
                          {isInputTypeDropDown && (
                            <div className={classes.dropdown}>
                              {inputTypeOptions.map((option, index) => {
                                return (
                                  <Grid item className={style.option} key={index}
                                    onClick={() => {
                                      handleInputTypeChange(option)
                                      setIsInputTypeDropDown(!isInputTypeDropDown)
                                    }}
                                  >
                                    {option}
                                  </Grid>
                                )
                              })
                              }
                            </div>
                          )}
                           <Typography className={style.errorText}>{inputTypeError.errorMsg}</Typography>
                      </Grid>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} md={6} style={{
                      textAlign: "left",paddingBottom:"20px",paddingLeft:"20px"
                    }}>
                    <Typography className={style.label}>Data format<span className={style.required}>*</span></Typography>
                    <FormControl className={style.input}>
                      <Grid container style={{height: '40px'}}>
                        <Grid container className={style.formInput}
                        style={{ cursor: 'pointer' }}
                        alignContent="center"
                        onClick={() => setIsFormatDropDown(!isFormatDropDown)}
                        >
                          <Grid item style={{ flex: 1 }}>
                            <input
                              disabled={type === "view"}
                              placeholder="Select Format Type"
                              className={classes.optionInput}
                              value={type === "view" ? parameters[index].format : format}
                              onChange={(e) => setFormat(e.target.value)}
                            />
                          </Grid>
                          <Grid item> {isFormatDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                          </Grid>
                          {isFormatDropDown && (
                            <div className={classes.dropdown}>
                              {formatOptions.map((option, index) => {
                                return (
                                  <Grid item className={style.option} key={index}
                                    onClick={() => {
                                      handleFormatChange(option)
                                      setIsFormatDropDown(!isFormatDropDown)
                                    }}
                                  >
                                    {option}
                                  </Grid>
                                )
                              })
                              }
                            </div>
                          )}
                        </Grid>
                    </FormControl>
                    <Typography className={style.errorText}>{formatError.errorMsg}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    md={6}
                    style={{ textAlign: "left", paddingBottom: "20px" }}
                  >
                    <Typography className={style.label}>Default Value<span className={style.required}>*</span> &nbsp;
                    <Tooltip
                          arrow
                          title={
                            <React.Fragment>
                              <Grid container>
                                <Grid item xs={12} md={12}>
                                  <Typography
                                    style={{fontSize: "12px", color: '#FFFFFF', fontWeight: 300, fontFamily: 'poppins'}}
                                  >{"Use curly braces {} to specify values that vary by device. For example, "}<br/>
                                  {"S2D/SA/VA/{deviceId}"}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </React.Fragment>
                          }
                          interactive
                          placement="right"
                        >
                         <IconButton style={{padding: "1px 2px 2px 0px"}}>
                            <QuestionIcon/>
                          </IconButton>
                        </Tooltip>
                    </Typography>
                    <FormControl className={style.input}>
                    <input
                      className={style.formInput}
                      disabled={type === "view" ||format === ""}
                      onChange={(e) => {
                        setDefaultVal(e.target.value);
                        if(format=="Char" && e.target.value.length>1){
                        setDefaultValueError({error:true,errorMsg:"Cannot add more than 1 character"})
                        }
                        else{
                          setDefaultValueError({error:false,errorMsg:""})
                        }}}
                      value={
                         type === "view"
                          ? parameters[index].defaultValue
                          : defaultVal
                      }
                    />
                      
                    </FormControl>
                    {defaultValueError.error && (
                        <Typography className={style.errorText}>
                          {defaultValueError.errorMsg}</Typography>
                      )}
                  </Grid>
                  
                  <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px" , paddingLeft: "20px" }}>
                    <Typography className={style.label}>Join Parameter</Typography>
                    <FormControl className={style.input}>
                      <Select
                        disabled={type === "view" ? true : false}
                        id="demo-customized-select-native"
                        value={
                          type === "view" ? parameters[index].joinParameter : join
                        }
                        className={style.input}
                        onChange={selectJoin}
                        multiple
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                        renderValue={(selected: string[]) => (
                          <div>
                            {selected.map((value, i) => (
                              <Chip
                                key={i}
                                label={value}
                                className={style.chip}
                                onMouseDown={(event) => {
                                  event.stopPropagation();
                                }}
                                onDelete={() => removeJoin(value)}
                              />
                            ))}
                          </div>
                        )}
                        input={<BootstrapInput />}
                      >
                        {type === "add-new" ? (
                          parameters
                            .filter((obj) => obj.parameterCategory === mainType)
                            .map((p, j) => {
                              return (
                                <MenuItem value={p.parameterId} key={j}>
                                  <ListItemText
                                    primary={p.parameterId}
                                    style={{ color: primaryGray }}
                                  />
                                </MenuItem>
                              );
                            })
                        ) : type === "edit" ? (
                          parameters
                            .filter((obj) => obj.parameterCategory === mainType)
                            .filter((ob) => ob.parameterId !== parameters[index].parameterId)
                            .map((p, j) => {
                              return (
                                <MenuItem value={p.parameterId} key={j}>
                                  <ListItemText
                                    primary={p.parameterId}
                                    style={{ color: primaryGray }}
                                  />
                                </MenuItem>
                              );
                            })
                        ) : (
                          <div></div>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            {(addParameter && type !== "view") && (
              <DialogActions style={{ display: 'flex', justifyContent: 'flex-end', paddingLeft: '590px', paddingBottom: '20px' }}>
                <Button className={style.backButton} variant="contained" onClick={() => closeAddParameter()}>Cancel</Button>
                <Button className={style.saveButton}
                  variant="contained"
                  onClick={() => {
                    readParameters({
                      parameterCategory: mainType,
                      parameter,
                      parameterId: id,
                      inputType,
                      format,
                      joinParameter: join,
                      defaultValue: defaultVal
                    });
                  }}
                >
                  {type === "edit" ? "Update" : "Save"}
                </Button>
              </DialogActions>
            )}
            {(!addParameter && type !== "view") && (
              <DialogActions style={{ display: 'flex', justifyContent: 'flex-end', paddingLeft: '590px', paddingBottom: '20px' }}>
                <Button className={style.backButton} variant="contained" onClick={addParameterCancel}>Cancel</Button>
                <Button className={style.saveButton}
                  variant="contained"
                  onClick={() => {
                    if (!hasPackagePermission("RemoteManager")) {
                      showFeatureUnavailablePopup('Remote Manager');
                    } else {
                      addParameterDone();
                    }
                  }}  
                  disabled={parameters.length === 0}
                >
                  Done
                </Button>
              </DialogActions>
            )}
          </Dialog>
        )}
      </>


      {!isToggled && (
         <>
           <Grid item container xs={12} md={12} alignItems="center" style={{ marginBottom: "20px" }}>
           {errors.codecError && (
                  <span className="form-error">
                    {errors.codecError}
                  </span>
                )}
  <Grid container>
    <Grid item xs={12} md={12}>
      <Grid container>

        {/* SELECT CODEC METHOD */}
        <Grid item xs={12} md={6}
              onClick={() => setStep("select")}
              className={`${style.formInput} ${style.codecButton}`}
              style={{
                borderBottom: step === "select" ? "3px solid #2A7CED" : "1px solid #ccc", }}
        >
           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
  <span style={{ marginLeft: '8px' }}></span> 
  SELECT CODEC METHOD
</div>
            
          
        </Grid>

        {/* CREATE CODEC */}
        <Grid item xs={12} md={6}
              onClick={() => setStep("create")}
              className={`${style.formInput} ${style.codecButton}`}
              style={{
                borderBottom: step === "create" ? "3px solid #2A7CED" : "1px solid #ccc", 
              }}
        >
         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
  <span style={{ marginLeft: '8px' }}></span> 
  CREATE CODEC
</div>

        </Grid>

    </Grid>
  </Grid>
</Grid>

          </Grid>

          {/* create codec form elements */}
          {step === 'create' && (
            <Grid item xs={12} md={12} style={{ marginBottom: "20px" }}>
              <Grid item xs={12} md={12}>
                <Grid container alignItems="center">
                    <AddNewDecoder
                      onClose={handleSelectCodecClick}
                      codecs={codecs}
                      onCodecToPlaceholder={handleCodecCreation}
                      successCallback={successCallback}
                    />
                </Grid>
              </Grid>
            </Grid>
          )}

          {/* select codec form elements */}
          {step !== 'create' && (
           <Grid item xs={12} md={12} style={{ marginBottom: "20px" }}>
              <Grid item xs={12} md={12}>
                <Grid container alignItems="center">
                    <FormControl className={style.input}>
                      <Grid container style={{height: '40px'}}>
                        <Grid container className={style.formInput}
                          style={{ cursor: 'pointer' }}
                          alignContent='center'
                          onClick={() => setIsCodecDropDown(true)}
                        >
                          <Grid item style={{ flex: 1 }}>
                            <input
                              placeholder={codecToSend === '' ? "Select Codec" : codecToSend}
                              className={classes.optionInput}
                              value={selectedCodec}
                              //onChange={() => setIsCodecDropDown(true)}
                              onChange={(e) => setSelectedCodec(e.target.value)}
                              readOnly={true}
                            />
                          </Grid>
                          <Grid item> {isCodecDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                        </Grid>
                        {isCodecDropDown && (
                          <div style={{ width: '100%', zIndex: 1 }}>
                            <div className={classes.dropdown}>
                              {codecs.map((codec, index) => {
                                return (
                                  <Grid item xs={12} md={12}
                                        className={style.option}
                                        key={index}
                                        onClick={() => {
                                          handleCodecChange(codec.codecName)
                                        }}
                                  >
                                    <span style={{ marginLeft: '10px' }}> {codec.codecName} </span>
                                  </Grid>
                                )
                              })
                              }
                            </div>
                            <div style={{ marginTop: '20px' }} />
                          </div>
                        )}
                      </Grid>
                    </FormControl>
                  </Grid>
                </Grid>
            </Grid>
          )}
        </>
      )}

<Grid item xs={12} md={12}>
        <Grid item xs={12} md={12}>
          <Grid container alignItems="center">
            <Grid item xs={8} md={9}>
              <FormGroup>
                <FormControlLabel
                  label="Add Another Product"
                  control={
                    <Checkbox
                      className={style.radio}
                      checked={addAnotherProduct}
                      onChange={handleCheckboxChange}
                    />
                  }
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1} md={3}></Grid>
      </Grid>

      </Grid> 

      <Grid container  justifyContent="flex-end" style={{ marginTop:"20px"}}>
          <Button
            className={style.backButton}
            variant="contained"
            color="secondary"
            style={{
              marginRight: '10px'
            }}
            onClick={handleBack}
          >
            Back
          </Button>
          <Button 
            className={style.saveButton} 
            variant="contained"
            color="primary"
            style={{

              boxShadow: 'none',
              height:"40px",
             
            }}
            onClick={handleSave}
          >
            Save
          </Button>
        </Grid>
      </Grid>
      <Snackbar
        open={toaster}
        autoHideDuration={6000}
        onClose={handleCloseToaster}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseToaster}
          severity={reqSuccess === true ? "success" : "error"}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
      {loading &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80} />
        </div>
      }
    </div>
    {showNotAvailablePopup && (
      <NotAvailablePopup
        open={showNotAvailablePopup.open}
        onClose={() => setShowNotAvailablePopup({...showNotAvailablePopup, open: false})}
        onCloseWithFeature={() => {
            setShowNotAvailablePopup({...showNotAvailablePopup, open: false});
            if (showNotAvailablePopup.featureName === 'Remote Manager') {
              addParameterDone();
            } else if (showNotAvailablePopup.featureName === 'OTA Manager') {
              setOpenOTA(false); 
            }
          }}
        featureName={showNotAvailablePopup.featureName}
        onUpgrade={() => {
          setShowNotAvailablePopup({ ...showNotAvailablePopup, open: false });

          window.open(environment.azurepageLink);
        }}
      />
    )}
    </ThemeProvider>
  );
}

const local= makeStyles((theme: Theme) => ({
  dropDownGrid: {
    backgroundColor: white,
    border: '1px solid #C7C4C4',
    borderRadius: '5px',
    maxHeight: '200px',
    overflowY: 'auto',
    marginTop: '40px',
    zIndex:10,
    position: 'absolute'
  },
  dropdown: {
    textAlign: 'left',
    border: '1px solid #C7C4C4',
    borderRadius: '5px',
    backgroundColor: white,
    width: '100%',
    zIndex: 1,
    maxHeight: '160px',
    overflowY: 'auto',
  },
  optionInput: {
    cursor: 'pointer',
    border: 'none',
    fontFamily: "'Poppins', sans-serif"
  },
  helperText: {
    color: "red",
    fontSize: "small",
    paddingTop: "7px",
  },
  popup: {
    backgroundColor: "#CEEBCE",
  },
  questionTooltip: {
    backgroundColor: "#334B5A",
    color: 'white',
    borderRadius: '4px',
    padding: '10px',
    fontSize: '12px',
  },
  input: {
    width: "100%",
    textAlign: "left",
  },
  label: {
    fontSize: "15px",
    color: primaryGray,
    paddingBottom: "5px",
  },
  chip: {
    borderRadius: "4px",
    backgroundColor: "#C7C4C436",
    marginLeft: "5px",
  },
  inputDefaultValue: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
  },
  labelDefaultValue: {
    marginBottom: "20px",
  },
  chipDefault: {
    borderRadius: "2px",
    backgroundColor: "#C7C4C436",
    marginLeft: "2px",
    marginBottom: "10px",
  },
  addIcon:{
    margin: "5px 0px 0px 10px",
    display: 'flex', 
    alignItems: 'center', 
    cursor: 'pointer'
  }
  


}));
export default local;
